import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CloudDownloadRounded from '@mui/icons-material/CloudDownloadRounded';
import DeleteForever from '@mui/icons-material/DeleteForever';
import MoreVert from '@mui/icons-material/MoreVert';
import {
  Avatar,
  Box,
  Button,
  Dropdown,
  MenuButton,
  MenuItem,
  Modal,
  Stack,
  Typography,
} from '@mui/joy';
import DialogContent from '@mui/joy/DialogContent';
import DialogTitle from '@mui/joy/DialogTitle';
import IconButton from '@mui/joy/IconButton';
import ListDivider from '@mui/joy/ListDivider';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import Menu from '@mui/joy/Menu';
import ModalDialog from '@mui/joy/ModalDialog';
import * as React from 'react';
import useFile from '../../hooks/useFile';

export const LibraryFileDetailsModal = (props: {
  toggleModal: (show: boolean) => void;
  show: boolean;
  fileId: string;
  deleteFile: (fileId: string) => Promise<void>;
}) => {
  const { toggleModal, show, fileId, deleteFile } = props;
  const fileQuery = useFile(fileId);

  if (!fileId || !fileQuery.isSuccess) {
    return null;
  }

  const file = fileQuery.data;

  const handleDownload = ({
    filename,
    href,
  }: {
    href: string;
    filename: string;
  }) => {
    const link = document.createElement('a');
    link.href = href;
    link.download = filename || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  let owner = 'Onbekend';
  if (file?.owner) {
    owner = `${file.owner.firstName} ${file.owner?.lastName || ''}`;
  }

  const fileName =
    file?.title +
    '.' +
    file?.fileUrl.slice(file.fileUrl.length - 3, file.fileUrl.length);

  return (
    <React.Fragment>
      <Modal open={show} onClose={() => toggleModal(!show)}>
        <ModalDialog>
          <DialogTitle>
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              sx={{ width: '100%' }}
              alignItems={'center'}
            >
              <Typography>{fileName}</Typography>

              <Dropdown>
                <MenuButton
                  slots={{ root: IconButton }}
                  slotProps={{
                    root: { variant: 'soft', color: 'neutral' },
                  }}
                  sx={{ width: '1.5rem', height: '1.5rem' }}
                >
                  <MoreVert />
                </MenuButton>
                <Menu placement="bottom-end" sx={{ zIndex: 99999 }}>
                  <MenuItem
                    onClick={() => {
                      handleDownload({
                        href: file.fileUrl,
                        filename: file.title,
                      });
                    }}
                  >
                    <ListItemDecorator sx={{ color: 'inherit' }}>
                      <CloudDownloadRounded />
                    </ListItemDecorator>
                    Downloaden
                  </MenuItem>
                  <ListDivider />
                  <MenuItem
                    variant="soft"
                    color="danger"
                    onClick={async () => {
                      await deleteFile(file._id);
                    }}
                  >
                    <ListItemDecorator sx={{ color: 'inherit' }}>
                      <DeleteForever />
                    </ListItemDecorator>
                    Verwijderen
                  </MenuItem>
                </Menu>
              </Dropdown>
            </Stack>
          </DialogTitle>
          <Stack spacing={5}>
            <DialogContent>
              <Stack
                justifyContent={'space-between'}
                direction={'row'}
                spacing={3}
              >
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  sx={{ marginTop: '.5rem' }}
                >
                  <Avatar src={file?.owner?.imageUrl} />
                  <Typography level="body-sm" className="pl-2">
                    {owner}
                  </Typography>
                </Stack>
              </Stack>
              {file.fileUrl && (
                <Box sx={{ maxWidth: '20rem', margin: '.5rem 0' }}>
                  <img
                    src={file?.fileUrl}
                    loading="lazy"
                    alt=""
                    style={{
                      borderRadius: '.5rem',
                      border: '1px solid #e0e0e0',
                    }}
                  />
                </Box>
              )}
            </DialogContent>

            <Button
              startDecorator={<CloseRoundedIcon />}
              onClick={() => {
                toggleModal(false);
              }}
            >
              Sluiten
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
};
